export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  imageWidth: number;
  imageHeight: string;
  imageSeq: string;
  imageQuery: string;
  authorName: string;
  authorRole: string;
  publishedAt: string;
  isExclusive: boolean;
  isHot: boolean;
  tags: string[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  iconClass: string;
}

export interface HotComment {
  id: string;
  articleSlug: string;
  comment: string;
  author: string;
  role: string;
}

export const categories: Category[] = [
  { slug: 'wanghong-heidiao', name: '网红黑料', description: '最新网红爆料、黑历史深扒', iconClass: 'ri-user-search-line' },
  { slug: 'mingxing-tafang', name: '明星塌房', description: '明星绯闻、人设崩塌全纪录', iconClass: 'ri-star-line' },
  { slug: 'zhibo-chigua', name: '直播吃瓜', description: '直播间热瓜、主播翻车现场', iconClass: 'ri-live-line' },
  { slug: 'yule-bagua', name: '娱乐八卦', description: '娱乐圈最新猛料深度扒皮', iconClass: 'ri-chat-smile-2-line' },
  { slug: 'shipin-heiliao', name: '黑料视频', description: '独家视频爆料、现场直击', iconClass: 'ri-video-line' },
  { slug: 'meiri-redian', name: '每日热点', description: '今日必看热门大瓜汇总', iconClass: 'ri-fire-line' },
  { slug: 'shenye-fangtan', name: '深夜访谈', description: '圈内人独家深度访谈', iconClass: 'ri-moon-line' },
  { slug: 'chigua-baike', name: '吃瓜百科', description: '事件始末完整梳理', iconClass: 'ri-book-open-line' },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'dingji-wanghong-beihou-ziben-jiaoyi-neimu',
    title: '顶流网红背后资本交易内幕曝光，涉及金额超千万',
    excerpt: '据知情人士透露，某拥有三千万粉丝的顶流网红背后存在复杂的资本运作网络，多笔交易涉嫌违规操作，相关证据已提交监管部门。',
    content: '<p>近日，一位不愿具名的业内人士向17吃瓜网爆料，某位在全网拥有超过三千万粉丝的顶流网红，其背后运作团队存在严重的资本违规问题。</p><p>据该知情人士透露，这位网红在过去两年间通过多层壳公司与多家MCN机构进行利益输送，涉及金额累计超过千万级别。相关合同中存在明显的不合理条款，包括虚假流量购买、数据造假以及利用粉丝信任进行不当营销等行为。</p><p>"这些操作在圈内其实已经不是秘密，但一直没有人敢站出来说。"该知情人士表示，"这次之所以选择爆料，是因为实在看不下去了。"</p><p>目前，相关证据已经提交至市场监管部门，17吃瓜网将持续追踪事件进展。</p><p>值得注意的是，该网红近日突然停更所有社交平台账号，其工作室也处于失联状态。多位与其有商业合作的品牌方已开始紧急公关，试图与其切割关系。</p><p>业内人士分析认为，此事件可能引发整个网红行业的连锁反应，相关部门或将出台更严格的监管措施。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heidiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20silhouette%20of%20a%20person%20behind%20a%20curtain%2C%20dramatic%20lighting%2C%20warm%20coral%20and%20deep%20teal%20color%20accents%2C%20cinematic%20film%20noir%20style%2C%20investigative%20journalism%20mood%2C%20abstract%20geometric%20shapes%2C%20professional%20editorial%20photography%20with%20soft%20shadows%2C%20clean%20minimalist%20composition%2C%20high%20contrast&width=1600&height=1000&seq=article-1-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-1-hero',
    imageQuery: 'Dark mysterious atmosphere with silhouette of a person behind a curtain, dramatic lighting, warm coral and deep teal color accents, cinematic film noir style, investigative journalism mood, abstract geometric shapes, professional editorial photography with soft shadows, clean minimalist composition, high contrast',
    authorName: '深度调查组',
    authorRole: '17吃瓜网首席调查记者',
    publishedAt: '2026-07-07',
    isExclusive: true,
    isHot: true,
    tags: ['网红', '资本运作', '内幕曝光', 'MCN', '违规操作'],
  },
  {
    id: '2',
    slug: 'zhibo-yijie-dangzhong-fanche-shijian-quanjing',
    title: '直播一姐直播中当场翻车，人设彻底崩塌全过程',
    excerpt: '以"真实不做作"人设走红的某直播平台一姐，在近日的一场直播中因意外事件导致精心维护的人设瞬间崩塌，引发全网热议。',
    content: '<p>昨晚，在某直播平台拥有超过两千万粉丝的"直播一姐"在例行直播中发生了一起令所有人瞠目的翻车事件。</p><p>事情起因于她在介绍一款"自用推荐"护肤品时，被直播间观众发现背景中出现了大量未拆封的品牌竞品。更尴尬的是，在切换镜头时，观众清楚地看到桌上放着多份不同品牌的产品代言合同。</p><p>直播间弹幕瞬间炸锅，"人设崩塌""原来都是演的"等评论刷屏。该主播试图解释但语无伦次，最终匆忙下播。</p><p>事后，多个品牌方纷纷发布声明与其划清界限，而她的粉丝群也在短时间内流失超过百万。</p><p>一位直播行业资深从业者分析称："这个行业的信任危机一直在积累，这次事件可能只是一个开始。观众越来越聪明，靠人设吃饭的时代正在过去。"</p>',
    category: '直播吃瓜',
    categorySlug: 'zhibo-chigua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20ring%20light%20and%20camera%20equipment%2C%20chaotic%20atmosphere%2C%20warm%20coral%20pink%20accent%20lighting%2C%20scattered%20product%20boxes%20on%20table%2C%20cinematic%20documentary%20style%2C%20tension%20and%20drama%20mood%2C%20clean%20background%20with%20dark%20teal%20shadows%2C%20editorial%20photography&width=1600&height=1000&seq=article-2-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-2-hero',
    imageQuery: 'Dramatic live streaming studio scene with ring light and camera equipment, chaotic atmosphere, warm coral pink accent lighting, scattered product boxes on table, cinematic documentary style, tension and drama mood, clean background with dark teal shadows, editorial photography',
    authorName: '直播观察员',
    authorRole: '17吃瓜网直播频道编辑',
    publishedAt: '2026-07-06',
    isExclusive: false,
    isHot: true,
    tags: ['直播翻车', '人设崩塌', '直播带货', '网红', '品牌解约'],
  },
  {
    id: '3',
    slug: 'dingliu-nanyixing-ganqing-chugui-bei-paidao',
    title: '顶流男艺人深夜约会神秘女子，疑似感情出轨被拍到实锤',
    excerpt: '某顶流男艺人在深夜被拍到与一名神秘女子亲密同行，而其公开女友正在国外拍戏，疑似感情出轨实锤。',
    content: '<p>昨晚11时许，有网友在北京某高端酒店门口拍到了一组令人震惊的照片。照片中，一位拥有超高人气的一线男艺人正与一名身材高挑的神秘女子亲密同行，两人行为举止亲昵，完全不避讳外人的目光。</p><p>值得注意的是，该男艺人的公开女友——同样是圈内知名女演员——目前正在国外拍摄一部好莱坞大片，两人在社交媒体上一直以"模范情侣"形象示人。</p><p>照片一经发布便迅速引爆网络，相关话题在短时间内登上多个热搜榜首位。粉丝们纷纷表示"无法接受"，但也有一些理性的声音认为"明星也是普通人，感情的事情很难说清楚"。</p><p>截至发稿时，该男艺人及其工作室均未对此事作出任何回应，而其女友的社交账号也处于静默状态。</p><p>业内人士透露，该男艺人目前有多部待播剧和综艺节目，此次事件可能对其商业价值造成重大影响。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Night%20scene%20outside%20luxury%20hotel%20entrance%20with%20blurred%20silhouettes%20of%20two%20people%20walking%20closely%2C%20warm%20golden%20lighting%20from%20hotel%20lobby%2C%20paparazzi%20style%20photography%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20mood%2C%20dark%20teal%20night%20sky%2C%20clean%20composition%20with%20leading%20lines&width=1600&height=1000&seq=article-3-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-3-hero',
    imageQuery: 'Night scene outside luxury hotel entrance with blurred silhouettes of two people walking closely, warm golden lighting from hotel lobby, paparazzi style photography, mysterious atmosphere, cinematic noir mood, dark teal night sky, clean composition with leading lines',
    authorName: '娱乐追光者',
    authorRole: '17吃瓜网娱乐版主编',
    publishedAt: '2026-07-06',
    isExclusive: true,
    isHot: true,
    tags: ['顶流男星', '感情出轨', '深夜约会', '实锤', '塌房'],
  },
  {
    id: '4',
    slug: 'duanshiping-mingxing-jimi-juhui-baoguang',
    title: '多位短视频达人秘密聚会照片流出，疑似组建神秘联盟',
    excerpt: '一张多位头部短视频达人私下聚会的照片在社交平台疯传，照片中众人神情严肃，疑似在商讨某种行业联盟计划。',
    content: '<p>今日凌晨，一张拍摄于上海某私人会所的照片在各大社交平台迅速传播。照片中出现的是六位在全网拥有千万级粉丝的短视频头部达人，他们围坐在一张圆桌前，桌上摆放着多份文件。</p><p>据拍摄者称，这场聚会持续了近四个小时，期间没有任何工作人员在场，所有手机都被要求放在门外的保管箱中。</p><p>"这种级别的达人私下聚在一起，而且搞得这么神秘，绝对不是简单的朋友聚会。"一位不愿具名的MCN机构负责人分析称。</p><p>有传言称，这些达人正在策划建立一个独立的创作者联盟，以对抗各大MCN机构对创作者的过度抽成和不公平合约条款。如果这一联盟成立，将对整个短视频行业产生深远影响。</p><p>目前，照片中的六位达人均未对此事发表任何评论。</p>',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Private%20meeting%20room%20with%20round%20table%2C%20six%20silhouettes%20seated%20around%2C%20dim%20warm%20coral%20accent%20lighting%2C%20documents%20spread%20on%20table%2C%20secretive%20atmosphere%2C%20mysterious%20and%20dramatic%20mood%2C%20cinematic%20lighting%2C%20deep%20teal%20shadows%20in%20corners%2C%20professional%20editorial%20photography&width=1600&height=1000&seq=article-4-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-4-hero',
    imageQuery: 'Private meeting room with round table, six silhouettes seated around, dim warm coral accent lighting, documents spread on table, secretive atmosphere, mysterious and dramatic mood, cinematic lighting, deep teal shadows in corners, professional editorial photography',
    authorName: '行业观察家',
    authorRole: '17吃瓜网特约评论员',
    publishedAt: '2026-07-05',
    isExclusive: false,
    isHot: false,
    tags: ['短视频', '达人聚会', '神秘联盟', '行业动态', 'MCN'],
  },
  {
    id: '5',
    slug: 'zhiming-zhubo-bei-zha-juanqian-paolu-jingren-zhenxiang',
    title: '知名女主播被曝卷钱跑路，涉案金额惊人，受害者已报案',
    excerpt: '某直播平台知名女主播被多名粉丝联合举报，称其以各种名义向粉丝借款后突然失联，初步统计涉案金额超五百万元。',
    content: '<p>近日，多位网友向17吃瓜网反映，某直播平台一位拥有百万粉丝的知名女主播在向大量粉丝借款后突然失联，所有社交账号均已停更，电话也无法接通。</p><p>据受害者自发组织的维权群统计，目前已有超过200名粉丝声称受到该主播的诈骗，金额从几千元到数十万元不等，总计超过五百万元。该主播主要通过"家里有急事""需要资金周转""一起投资赚钱"等借口向信任她的粉丝借钱。</p><p>"我借给她了八万块，她说下个月就还，结果人就不见了。"一位受害者哭诉道。</p><p>目前，部分受害者已经向当地公安机关报案，警方正在对此案进行调查。</p><p>该主播所在直播平台已发布声明称将全力配合警方调查，并表示已对该主播的账号进行封禁处理。</p><p>这起事件再次引发了社会对直播打赏文化和粉丝经济的反思。法律专家提醒广大网友，涉及金钱交易务必保持警惕，不要轻易相信网络上的"熟人"。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heidiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20dark%20apartment%20with%20packed%20luggage%20near%20door%2C%20abandoned%20streaming%20equipment%20gathering%20dust%2C%20eerie%20atmosphere%2C%20warm%20coral%20light%20from%20window%2C%20deep%20teal%20shadows%2C%20crime%20scene%20documentary%20photography%20style%2C%20sense%20of%20betrayal%20and%20loss%2C%20professional%20editorial%20composition&width=1600&height=1000&seq=article-5-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-5-hero',
    imageQuery: 'Empty dark apartment with packed luggage near door, abandoned streaming equipment gathering dust, eerie atmosphere, warm coral light from window, deep teal shadows, crime scene documentary photography style, sense of betrayal and loss, professional editorial composition',
    authorName: '权益保护组',
    authorRole: '17吃瓜网调查记者',
    publishedAt: '2026-07-04',
    isExclusive: true,
    isHot: false,
    tags: ['女主播', '卷钱跑路', '诈骗', '粉丝', '报案'],
  },
  {
    id: '6',
    slug: 'remen-zongyi-bianju-bei-zhi-chaojiao-huati-beihou',
    title: '热门综艺编剧被曝操纵舆论，炒作话题背后真相惊人',
    excerpt: '一位曾在某热门综艺担任编剧的业内人士匿名爆料，揭露了节目组如何系统性策划热搜话题、操控观众情绪的完整流程。',
    content: '<p>一位自称在某热门综艺节目担任编剧长达三年的匿名人士，近日向17吃瓜网提供了一份长达二十页的内部文档，详细记录了节目组如何通过"剧本化"操作来制造热搜话题。</p><p>根据该文档显示，节目组设有一个专门的"话题策划小组"，负责在每期节目录制前制定详细的"热搜路线图"。从冲突设计、情绪引爆点到后续发酵节奏，每一个环节都有精密安排。</p><p>"观众以为自己在看真人秀，实际上看的是一场精心设计的戏。"该爆料人表示，"甚至连选手之间的矛盾、和解的时机都是提前写好的。"</p><p>该文档还显示，节目组与多家营销公司有长期合作关系，每次节目播出前后都会启动"舆论操控预案"，包括水军引导、大V转发、话题接力等。</p><p>此爆料一出，立刻引发了观众对综艺节目真实性的广泛质疑。多位影视评论人呼吁行业加强自律和监管。</p>',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20production%20studio%20with%20cameras%20and%20crew%2C%20storyboard%20documents%20pinned%20on%20wall%2C%20dramatic%20split%20lighting%2C%20warm%20coral%20and%20deep%20teal%20color%20palette%2C%20documentary%20style%2C%20manipulation%20and%20truth%20contrast%2C%20professional%20editorial%20photography%20with%20clean%20composition&width=1600&height=1000&seq=article-6-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-6-hero',
    imageQuery: 'Behind the scenes of TV production studio with cameras and crew, storyboard documents pinned on wall, dramatic split lighting, warm coral and deep teal color palette, documentary style, manipulation and truth contrast, professional editorial photography with clean composition',
    authorName: '媒体透视镜',
    authorRole: '17吃瓜网资深媒体观察员',
    publishedAt: '2026-07-03',
    isExclusive: false,
    isHot: true,
    tags: ['综艺', '编剧爆料', '幕后真相', '热搜', '舆论操控'],
  },
  {
    id: '7',
    slug: 'wangluo-geshou-bei-zhi-jia-chang-tuolaji-qizha',
    title: '网络歌手被前经纪人实名举报，涉嫌多起合同欺诈案件',
    excerpt: '某网络歌手的原经纪人在社交媒体发布实名举报信，列举了该歌手的多项违规行为，涉及合同欺诈、恶意拖欠分成等问题。',
    content: '<p>今日上午，一位自称是某知名网络歌手原经纪人的用户，在微博发布了一封长达5000字的实名举报信，详细列举了该歌手在过去三年间的多项违规行为。</p><p>举报信中称，该歌手在未经经纪人知情的情况下，私下与多家品牌方签订代言协议，导致原合同条款被严重违反。此外，该歌手还恶意拖欠经纪人应得的分成款项，金额高达数百万元。</p><p>"我为她付出了三年青春，换来的却是这样的结局。"该经纪人在举报信中写道。</p><p>举报信中还附带了多份合同的扫描件和转账记录截图，证据看起来十分详实。</p><p>该歌手目前尚未对此作出回应，但其工作室的微博账号已经关闭了评论功能。</p><p>法律界人士分析认为，如果举报内容属实，该歌手可能面临巨额的违约赔偿，其职业生涯也将受到严重打击。</p>',
    category: '网红黑料',
    categorySlug: 'wanghong-heidiao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Legal%20documents%20and%20contracts%20scattered%20on%20a%20dark%20desk%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20warm%20coral%20accent%20glow%2C%20deep%20teal%20background%2C%20investigative%20journalism%20mood%2C%20serious%20legal%20theme%2C%20professional%20editorial%20photography%2C%20clean%20minimalist%20composition&width=1600&height=1000&seq=article-7-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-7-hero',
    imageQuery: 'Legal documents and contracts scattered on a dark desk, dramatic side lighting creating long shadows, warm coral accent glow, deep teal background, investigative journalism mood, serious legal theme, professional editorial photography, clean minimalist composition',
    authorName: '法眼观察',
    authorRole: '17吃瓜网法律频道编辑',
    publishedAt: '2026-07-03',
    isExclusive: true,
    isHot: false,
    tags: ['网络歌手', '实名举报', '合同欺诈', '经纪人', '法律纠纷'],
  },
  {
    id: '8',
    slug: 'yulequan-dingji-jingjiren-neibu-zhenglu-baoguang',
    title: '娱乐圈顶级经纪人内部争斗录音曝光，涉及多位一线明星',
    excerpt: '一段长达四十分钟的内部会议录音近日被泄露至网络，两位顶级经纪人在会议中激烈争吵，讨论了多位一线明星的资源分配问题。',
    content: '<p>一段据称在某知名经纪公司内部会议上录制的音频，近日被匿名人士上传至多个平台。这段长达四十分钟的录音中，两位在国内娱乐圈极具影响力的顶级经纪人因为资源分配问题爆发了激烈争吵。</p><p>录音中明确提到了多位一线明星的名字，讨论了他们的商业价值排名、潜在的合作风险以及竞品之间的利益平衡等高度敏感的话题。</p><p>更令人震惊的是，录音中还涉及了一些行业内不为人知的"潜规则"，包括如何通过控制舆论来影响艺人商业价值、如何利用粉丝经济进行变现等操作细节。</p><p>这段录音的出现被业内视为一颗"重磅炸弹"，多位被提及的明星团队已经开始紧急公关。</p><p>"这是娱乐圈最不想让公众听到的声音。"一位资深娱记评论道。</p>',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Audio%20waveform%20visualization%20in%20dark%20room%2C%20dramatic%20red%20and%20teal%20lighting%2C%20leaked%20recording%20concept%2C%20mysterious%20corporate%20espionage%20atmosphere%2C%20cinematic%20noir%20style%2C%20tension%20and%20secrecy%2C%20abstract%20geometric%20patterns%2C%20professional%20editorial%20photography&width=1600&height=1000&seq=article-8-hero&orientation=landscape',
    imageWidth: 1600,
    imageHeight: '1000',
    imageSeq: 'article-8-hero',
    imageQuery: 'Audio waveform visualization in dark room, dramatic red and teal lighting, leaked recording concept, mysterious corporate espionage atmosphere, cinematic noir style, tension and secrecy, abstract geometric patterns, professional editorial photography',
    authorName: '内幕挖掘机',
    authorRole: '17吃瓜网独家爆料编辑',
    publishedAt: '2026-07-02',
    isExclusive: true,
    isHot: true,
    tags: ['经纪人', '内部录音', '娱乐圈', '资源分配', '潜规则'],
  },
];

export const hotComments: HotComment[] = [
  {
    id: '1',
    articleSlug: 'dingji-wanghong-beihou-ziben-jiaoyi-neimu',
    comment: '这个瓜实在是太大了！早就觉得有些网红突然蹿红有点不正常，原来背后都是资本在运作。这篇调查文章写得很到位，把整个利益链条都梳理清楚了。希望监管部门能够重视起来，还网红行业一个清朗的环境。这些靠数据造假、虚假营销起家的网红，就该被严查严惩！',
    author: '真相追寻者',
    role: '资深媒体人',
  },
  {
    id: '2',
    articleSlug: 'dingliu-nanyixing-ganqing-chugui-bei-paidao',
    comment: '又是一桩让人大跌眼镜的塌房事件。以前还觉得这对情侣挺般配的，没想到背后是这样的故事。明星们的感情真的经不起推敲，上一秒还是模范情侣，下一秒就各自精彩了。不过话说回来，感情的事外人确实不好评判，只是可惜了那些真心喜欢他们的粉丝。',
    author: '吃瓜群众代表',
    role: '娱乐评论人',
  },
  {
    id: '3',
    articleSlug: 'zhibo-yijie-dangzhong-fanche-shijian-quanjing',
    comment: '直播带货翻车的案例已经不是第一次了，但这次这位"一姐"级别的翻车确实让人震惊。说白了整个行业都存在严重的信任危机，消费者花了钱，主播赚了佣金，品牌方卖了货，结果最后大家都成了受害者。建议平台加强审核机制，对虚假宣传的主播零容忍。',
    author: '消费维权人士',
    role: '消费者权益保护协会理事',
  },
];

export const teamMembers = [
  {
    name: '张明远',
    role: '创始人 & 总编',
    description: '前主流媒体资深调查记者，拥有15年娱乐新闻报道经验，曾多次获得新闻行业大奖。',
    imageSeq: 'team-1',
    imageQuery: 'Professional Chinese male journalist in his 40s, confident expression, wearing casual blazer, warm coral background accent, editorial portrait photography, clean minimal composition, natural lighting, approachable yet authoritative look',
  },
  {
    name: '李思涵',
    role: '执行主编',
    description: '深耕娱乐产业报道10年，曾在多家头部娱乐媒体担任要职，拥有丰富的人脉资源和行业洞察力。',
    imageSeq: 'team-2',
    imageQuery: 'Professional Chinese female editor in her 30s, sharp intelligent look, modern office attire, warm background with teal accents, editorial portrait photography, clean composition, confident and approachable',
  },
  {
    name: '王浩然',
    role: '首席调查记者',
    description: '擅长深度调查报道，曾暗访曝光多起行业黑幕，作品多次引发社会广泛关注和讨论。',
    imageSeq: 'team-3',
    imageQuery: 'Chinese male investigative journalist in his 30s, determined expression, casual professional style, dark teal background, editorial portrait photography, cinematic lighting, serious yet approachable mood',
  },
  {
    name: '陈雨萱',
    role: '视频内容总监',
    description: '前头部短视频平台内容运营负责人，对视频内容策划和传播有独到见解和丰富经验。',
    imageSeq: 'team-4',
    imageQuery: 'Chinese female video content director in her 30s, creative energetic look, modern fashion style, coral pink warm background, editorial portrait photography, natural soft lighting, professional yet friendly',
  },
];

export const brandMilestones = [
  { year: '2019', title: '创立起点', description: '17吃瓜网正式上线，以"还原真相，传递价值"为使命，立志打造最专业的娱乐资讯平台。' },
  { year: '2020', title: '快速发展', description: '网站日均访问量突破百万，深度调查报道多次引发全网热议，行业影响力持续攀升。' },
  { year: '2021', title: '内容升级', description: '组建专业调查记者团队，推出多档原创深度栏目，获得业界广泛认可与好评。' },
  { year: '2022', title: '行业标杆', description: '被多家权威媒体评为"最具影响力的娱乐资讯平台"，累计用户突破五千万。' },
  { year: '2023', title: '视频拓展', description: '正式上线黑料视频频道，实现图文与视频内容的全方位覆盖，满足用户多元化需求。' },
  { year: '2024', title: '平台化发展', description: '构建创作者生态，邀请数百位资深娱记和行业专家入驻，打造权威娱乐内容矩阵。' },
  { year: '2025', title: 'AI赋能', description: '引入人工智能技术辅助内容审核和推荐，提升信息真实性和用户阅读体验。' },
  { year: '2026', title: '全球视野', description: '开始关注国际娱乐产业动态，拓展全球化的内容报道视野，服务更广泛的华语用户群体。' },
];

export const faqItems = [
  {
    question: '17吃瓜网的内容来源是否可靠？',
    answer: '17吃瓜网拥有专业的调查记者团队和严格的编辑审核流程。我们的每一篇报道都经过多重信息核实，确保内容的真实性和可靠性。对于尚在调查中的事件，我们会明确标注"持续关注中"，并随时更新最新进展。',
  },
  {
    question: '如何向17吃瓜网提供爆料线索？',
    answer: '您可以通过网站底部的"联系我们"表单或发送邮件至我们的官方邮箱提交爆料线索。我们郑重承诺对所有爆料人信息严格保密，并对有价值的线索提供相应报酬。',
  },
  {
    question: '17吃瓜网如何保护当事人隐私？',
    answer: '我们严格遵守相关法律法规，在报道中会对非公众人物的个人信息进行必要的模糊处理。同时，我们坚持"实事求是、客观公正"的报道原则，不恶意炒作、不诽谤中伤。',
  },
  {
    question: '可以在其他平台转载17吃瓜网的内容吗？',
    answer: '17吃瓜网的所有原创内容均受版权保护。如需转载，请通过官方渠道申请授权，并在转载时注明出处和作者信息。未经授权的转载行为将依法追究责任。',
  },
  {
    question: '如何加入17吃瓜网的创作团队？',
    answer: '我们长期欢迎有才华的记者、编辑和内容创作者加入。请将您的简历和代表作品发送至我们的招聘邮箱，我们的人事团队会在一周内给您回复。',
  },
];